export default __webpack_public_path__ + "static/media/clients.44a81627.png";